import React from 'react';

import { CreateShipmentIconButton } from '../../fulfillment-plan/create-shipment/create-shipment-icon-button';
import { NavigationPanel } from '../navigation-panel/navigation-panel';
import { messages } from './messages';
import { OrderOverviewButton } from '../../overview/navigation/order-overview-button';
import { ShipmentsPanelButton } from './shipments-panel-button';
import { useShipmentsPanelContext } from './shipments-panel-context-provider';

export const ShipmentsPanel = () => {
  const fulfillmentPlans = useShipmentsPanelContext();

  return (
    <>
      <OrderOverviewButton />
      <NavigationPanel headerActionButton={<CreateShipmentIconButton />} headerMessageDescriptor={messages.shipmentsPanelHeader}>
        {fulfillmentPlans.map(({ counter, fulfillmentPlanId }) => (
          <ShipmentsPanelButton key={fulfillmentPlanId} counter={counter} fulfillmentPlanId={fulfillmentPlanId} />
        ))}
      </NavigationPanel>
    </>
  );
};
